import type { AppState, Restaurant, User } from './types';

export const avatarOptions = [
  ['🐼', '#f6bd60'], ['🐯', '#f28482'], ['🐰', '#84a59d'], ['🦊', '#f5cac3'],
  ['🐸', '#90be6d'], ['🐨', '#a8dadc'], ['🐧', '#577590'], ['🐙', '#cdb4db'],
  ['🦁', '#f4a261'], ['🐵', '#bc6c25'], ['🐱', '#ffafcc'], ['🐶', '#8ecae6'],
  ['🦄', '#bde0fe'], ['🐹', '#e9c46a'], ['🐻', '#9c6644'], ['🐮', '#ccd5ae'],
  ['🐝', '#ffca3a'], ['🦋', '#9b5de5'], ['🐳', '#48cae4'], ['🦖', '#43aa8b'],
  ['🍊', '#fb8500'], ['🍙', '#adb5bd'], ['🥑', '#80b918'], ['🍓', '#e63946'],
] as const;

export const seedRestaurants: Restaurant[] = [
  {
    id: 'r-orange-noodles', name: '橙子面馆', category: '面食', address: '学校东门向南 180 米',
    longitude: 116.397128, latitude: 39.916527, averagePrice: 24, referenceRating: 4.5,
    referenceUpdatedAt: '2026-09-10T10:00:00+08:00', tags: ['出餐快', '适合工作日'], emoji: '🍜',
  },
  {
    id: 'r-friend-hotpot', name: '朋友火锅', category: '火锅', address: '研究生公寓商业街 2 层',
    longitude: 116.399128, latitude: 39.916527, averagePrice: 82, referenceRating: 4.3,
    referenceUpdatedAt: '2026-09-08T10:00:00+08:00', tags: ['多人聚餐', '可预约'], emoji: '🍲',
  },
  {
    id: 'r-lab-rice', name: '实验室盖饭', category: '快餐', address: '学院路 6 号',
    longitude: 116.3962, latitude: 39.9181, averagePrice: 19, referenceRating: 4.1,
    referenceUpdatedAt: '2026-09-05T10:00:00+08:00', tags: ['一个人也行', '午餐'], emoji: '🍛',
  },
  {
    id: 'r-night-bbq', name: '夜航烧烤', category: '烧烤', address: '北门夜市 16 号',
    longitude: 116.4013, latitude: 39.9194, averagePrice: 58, referenceRating: 4.6,
    referenceUpdatedAt: '2026-09-12T10:00:00+08:00', tags: ['夜宵', '朋友聚会'], emoji: '🍢',
  },
  {
    id: 'r-canton', name: '小满粤菜', category: '粤菜', address: '学府广场 3 层',
    longitude: 116.3944, latitude: 39.9148, averagePrice: 66, referenceRating: 4.4,
    referenceUpdatedAt: '2026-09-02T10:00:00+08:00', tags: ['清淡', '包间'], emoji: '🥢',
  },
  {
    id: 'r-dessert', name: '半糖研究所', category: '甜品饮品', address: '南门创意街 8 号',
    longitude: 116.4001, latitude: 39.9138, averagePrice: 21, referenceRating: 4.7,
    referenceUpdatedAt: '2026-09-11T10:00:00+08:00', tags: ['下午茶', '安静'], emoji: '🧋',
  },
];

export function createDemoState(user: User): AppState {
  const now = new Date().toISOString();
  return {
    version: 1,
    currentUser: user,
    users: [
      user,
      { id: 'demo-lin', displayName: '小林', avatar: '🐰', avatarColor: '#84a59d', role: 'MEMBER', joinedAt: now },
      { id: 'demo-zhou', displayName: '阿周', avatar: '🦊', avatarColor: '#f5cac3', role: 'MEMBER', joinedAt: now },
    ],
    restaurants: seedRestaurants,
    favorites: [
      { restaurantId: 'r-friend-hotpot', createdByUserId: user.id, createdAt: now, supporterUserIds: ['demo-lin'] },
      { restaurantId: 'r-night-bbq', createdByUserId: 'demo-zhou', createdAt: now, supporterUserIds: [user.id, 'demo-lin'] },
      { restaurantId: 'r-dessert', createdByUserId: 'demo-lin', createdAt: now, supporterUserIds: [] },
    ],
    ratings: [
      { id: 'rating-demo-1', restaurantId: 'r-night-bbq', userId: 'demo-lin', score: 4.5, comment: '适合组会结束后去。', createdAt: now },
      { id: 'rating-demo-2', restaurantId: 'r-friend-hotpot', userId: 'demo-zhou', score: 4, comment: '锅底不错，周末要排队。', createdAt: now },
    ],
    meals: [],
    draws: [],
    updatedAt: now,
  };
}
